import React from 'react';
import MapChart from './MapChart';

const Home = () => {
    return (
        <div>
            <p>
              Let's make the legal process easier throughout the whole world!
            </p>
            <MapChart />

        </div>
    );
}

export default Home;